<template>
  <page-listado>
    <page-header title="Tarifas">
      <b-button variant="primary" size="sm" to="/tarifas/crear">
        <v-icon name="plus" width="16" />
        Crear tarifa
      </b-button>
    </page-header>
    <tabla :tarifas="tarifas" @eliminar="eliminar" />
  </page-listado>
</template>

<script>
import tarifasApi from "@/services/tarifas.js";
import Tabla from "./TablaTarifas.vue";

export default {
  components: { Tabla },
  data() {
    return {
      tarifas: [],
    };
  },
  watch: {
    "$route.params": {
      handler: function () {
        this.listar();
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.listar();
  },
  methods: {
    async listar() {
      this.tarifas = await tarifasApi.listar(this.$route.query);
    },
    async eliminar(id) {
      await tarifasApi.eliminar(id);
      this.listar();
    },
  },
};
</script>
